import { Command } from './Command';
import { InsuredPatientCommandParams } from './InsuredPatientCommandParams';
import { NCZIReference } from '../Interfaces/ncziTypes';

export type WritePatientElectronicPrescriptionParams = InsuredPatientCommandParams & {
	urgentEmergency: boolean,
	nonPayer: boolean,
	prohibitionOfReplacement: boolean,
	prohibitionOfReplacementCode?: string | undefined,
	forcedEntry: boolean,
	forcedEntryReason?: string | undefined,
	productOnException: boolean,
	newbornToParentBN: boolean,
	permanentlyAffected: boolean,
	reportedDate: string,
	reportedQuantity: string,
	reportedDiagnosis: NCZIReference,
	reportedProductCode: string,
	reportedProductName: string,
	reportedProductAdditionalName: string,
	reportedATC?: NCZIReference | undefined,
	deviceUnit?: NCZIReference | undefined,
	deviceDescription?: string | undefined,
	deviceJustification?: string | undefined,
	atcAddon?: string | undefined,
	meddiPatient: {
		id: string,
		fullName: string,
		fullAddress: string
	},
	dosage: {
		type: string,
		note: string,
		prescription: string,
		methodOfAdministration: NCZIReference | undefined,
		dosageUnit: NCZIReference | undefined,
		periodicity: NCZIReference | undefined,
		treatmentTime: string | undefined,
		dailyDosage: {
			partsOfDay: string[] | undefined
			hourly: {
				amount: string,
				perHours: string
			} | undefined
		} | undefined
	},
	ipl?: {
		composition: string,
		prepareInstruction: string,
		useInstruction: string,
	} | undefined,
	repeat?: {
		period: number,
		count: number,
		validity: string,
	} | undefined,
	referrer?: {
		codeNZ: string,
		code: string,
		date: string,
	} | undefined,
	represented?: {
		codeNZ: string,
		code: string,
	} | undefined,
	patientPaymentReason?: string | undefined,
	withoutCard?: boolean | undefined,
	insurerGender: string,
	insurerState: string,
	pairOrganZone: string | undefined,
	excessQuantityDevice: boolean | undefined,
	approvedExemptionNumber: string | undefined,
	ventilator: {
		identificationNumber: string,
		codeNZ: string,
		settings: string
	} | undefined,
	quantityLimitDieteticFood: string | undefined,
	indicationLimitationCode:  string | undefined,
	disableMultiplePrescription: boolean | undefined,
};

export const WritePatientElectronicPrescription = (
	params: WritePatientElectronicPrescriptionParams,
): Command => {
	return {
		operation: 'UlozPreskripcnyZaznam_v6',
		params,
	};
};
